import { createStyles, getSize, rem } from '@mantine/styles';
var useStyles = createStyles(function (theme, _ref) {
  var padding = _ref.padding,
    withBorder = _ref.withBorder,
    inheritPadding = _ref.inheritPadding;
  var spacing = getSize({
    size: padding,
    sizes: theme.spacing
  });
  var offset = "calc(-1 * ".concat(spacing, ")");
  var borderColor = theme.colorScheme === "dark" ? theme.colors.dark[4] : theme.colors.gray[3];
  return {
    cardSection: {
      display: "block",
      marginLeft: offset,
      marginRight: offset,
      paddingLeft: inheritPadding ? spacing : void 0,
      paddingRight: inheritPadding ? spacing : void 0,
      borderTop: withBorder ? "".concat(rem(1), " solid ").concat(borderColor) : void 0,
      borderBottom: withBorder ? "".concat(rem(1), " solid ").concat(borderColor) : void 0,
      "& + &": {
        borderTop: 0
      },
      "&[data-first]": {
        marginTop: offset,
        borderTop: 0,
        borderBottom: withBorder ? "".concat(rem(1), " solid ").concat(borderColor) : void 0
      },
      "&[data-last]": {
        marginBottom: offset,
        borderBottom: 0
      }
    }
  };
});
export default useStyles;